// Chart library
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);
ChartJS.defaults.font.family = 'Palanquin';
ChartJS.defaults.font.size = 16;

const graphWidgetApp = {
    components: {
        Bar,
    },
    data() {
        return {
            dataTitle: null,
            dataYaxislabel: null,
            dataBgcolor: null,
            dataHovercolor: null,
            dataBordercolor: null,
            dataJson: null,
        };
    },
    computed: {
        chartData() {
            if (!this.dataJson) return { labels: [], datasets: [] };
            return {
                labels: this.dataJson.map(item => item.Title),
                datasets: [
                    {
                        data: this.dataJson.map(item => item.Value),
                        backgroundColor: this.dataBgcolor,
                        hoverBackgroundColor: this.dataHovercolor,
                        borderColor: this.dataBordercolor,
                    },
                ],
            }
        },
        chartOptions() {
            if (!this.dataJson) return {};

            let maxvalue = Math.max(...this.dataJson.map(item => item.Value));
            let suggestedMax = maxvalue + Math.round(maxvalue * 0.1);

            return {
                responsive: true,
                scales: {
                    y: {
                        title: {
                            display: true,
                            text: this.dataYaxislabel,
                        },
                        suggestedMax: suggestedMax
                    }
                },
                plugins: {
                    title: {
                        display: true,
                        color: '#1c71ab',
                        text: this.dataTitle,
                        font : {
                            size: 20,
                        },
                    },
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        padding: 8,
                        backgroundColor: '#fff',
                        titleFont: {
                            size: 0,
                        },
                        bodyColor: '#000',
                        borderColor: '#BDC1C6',
                        borderWidth: 1,
                        cornerRadius: 0,
                        displayColors: false,
                        caretSize: 0,
                        yAlign: 'bottom',
                    }
                },
            }
        }
    },
    mounted() {
        if (this.$el.dataset.json) this.dataJson = JSON.parse(this.$el.dataset.json);
        if (this.$el.dataset.title) this.dataTitle = this.$el.dataset.title;
        if (this.$el.dataset.yaxislabel) this.dataYaxislabel = this.$el.dataset.yaxislabel;
        if (this.$el.dataset.bgcolor) this.dataBgcolor = this.$el.dataset.bgcolor;
        if (this.$el.dataset.hovercolor) this.dataHovercolor = this.$el.dataset.hovercolor;
        if (this.$el.dataset.bordercolor) this.dataBordercolor = this.$el.dataset.bordercolor;
    },
};

export default graphWidgetApp;
